export type AccountRole = "Admin" | "Colaborador" | "Comum";
export interface AccountPageProps { role?: AccountRole; }
export const accountRoleLabel = (role: AccountRole) => role === "Admin" ? "Administrador" : role === "Colaborador" ? "Colaborador" : "Usuário comum";
